import React, { MouseEventHandler } from 'react';
import { SurveyNavigationButton } from 'survey-react-ui';

import { Button } from '../../../../components/atoms/button/button';

const buttonAppearance = (id: string) => {
  return id === 'sv-nav-prev' ? 'secondary' : 'primary';
};
const CustomNavigationButton = (props: {
  readonly text: string;
  readonly disabled: boolean;
  readonly id: string;
  readonly onMouseDown: MouseEventHandler<HTMLButtonElement>;
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
}) => {
  const { text, id, onMouseDown, onClick, disabled } = props;

  return (
    <Button
      appearance={buttonAppearance(id)}
      className={'!flex-grow !md:flex-grow-0'}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {text}
    </Button>
  );
};

const registerButtonOverride = (props: unknown): React.JSX.Element => {
  return React.createElement(ButtonOverride, props);
};
class ButtonOverride extends SurveyNavigationButton {
  override renderElement(): React.JSX.Element {
    return (
      <CustomNavigationButton
        disabled={this.item.disabled}
        id={this.item.id}
        onClick={this.item.action}
        onMouseDown={this.item?.data?.mouseDown}
        text={this.item.title}
      ></CustomNavigationButton>
    );
  }
}

export { buttonAppearance, ButtonOverride, registerButtonOverride };
